import type { ILocalStorage } from './i-local-storage';
import type { StorageKey } from './key-consts';

export const LocalStorage: ILocalStorage = {
  getItem(key: StorageKey) {
    return Promise.resolve(localStorage.getItem(key));
  },
  setItem(key: StorageKey, value: string) {
    localStorage.setItem(key, value);
    return Promise.resolve();
  },
  removeItem(key: StorageKey) {
    localStorage.removeItem(key);
    return Promise.resolve();
  },

  getItemSync_WebOnly(key: StorageKey) {
    return localStorage.getItem(key);
  },
  setItemSync_WebOnly(key: StorageKey, value: string) {
    localStorage.setItem(key, value);
  },
  removeItemSync_WebOnly(key: StorageKey) {
    localStorage.removeItem(key);
  },
};
